import { render, staticRenderFns } from "./ContentHeroSundayMobile.vue?vue&type=template&id=195dcd91&scoped=true&"
import script from "./ContentHeroSundayMobile.vue?vue&type=script&lang=js&"
export * from "./ContentHeroSundayMobile.vue?vue&type=script&lang=js&"
import style0 from "./ContentHeroSundayMobile.vue?vue&type=style&index=0&id=195dcd91&lang=scss&scoped=true&"
import style1 from "./ContentHeroSundayMobile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195dcd91",
  null
  
)

export default component.exports